import * as Mutations from '../../mutations';

export default {
  [Mutations.SET_USER](store, user) {
    store.user = user;
  },
  [Mutations.SET_TOKEN](store, token) {
    store.token = token;
  },
  [Mutations.SET_TEMPORARY_ACCESS_DATA](store, data) {
    store.temporaryAccessData = data;
  },
  [Mutations.SET_RECOVER_DATA](store, data) {
    store.recoverData = data;
  },
  [Mutations.SET_ACCESS_PENDING](store, data) {
    store.accessPending.push(data);
  },
  [Mutations.REMOVE_ACCESS_PENDING](store, data) {
    const pos = store.accessPending.indexOf(data);
    if (pos > -1) {
      store.accessPending.splice(pos, 1);
    }
  },
  [Mutations.CLEAR_ACCESS_PENDING](store) {
    store.accessPending = [];
  },
  [Mutations.SET_REFRESH_TOKEN_EXPIRED](store, isExpired) {
    store.isRefreshTokenExpired = isExpired;
  },
  [Mutations.SET_REFRESH_TOKEN_EXPIRATION](store, expiration) {
    store.refreshTokenExpiration = expiration;
  },
};
